// extracted by mini-css-extract-plugin
export default {"getPaidModal":"GetPaidModal_getPaidModal__rehYN","modalContent":"GetPaidModal_modalContent__rxrpc","modalTitle":"GetPaidModal_modalTitle__gFZba"};